function isInDataAccessGroupsPage() {
  return $("#data-access-groups").length > 0;
}
function isInS151TermsPage() {
  return $("#s151-termsPage").length > 0;
}
function isInMyRolesPage() {
  return $("#my-roles").length > 0;
}
function isInRequestApprovalPage() {
  return $("#request-approval-page").length > 0;
}
function isInCertifierRolesPage() {
  return $("#certifier-roles-page").length > 0;
}

// Handle the warning based on provide and certify data check box selection
if (isInMyRolesPage()) {
  setTimeout(function () {
    var bothProvideAndCertify =
      $('input[value="datamart-delta-data-certifiers"]').is(":checked") &&
      $('input[value="datamart-delta-data-providers"]').is(":checked");

    if (bothProvideAndCertify) {
      $("#provide-certify-warning").removeAttr("hidden");
    }
  }, 200);
  $('input[value="datamart-delta-data-certifiers"]').on("change", function () {
    if ($(this).is(":checked")) {
      if ($('input[value="datamart-delta-data-providers"]').is(":checked")) {
        $("#provide-certify-warning").removeAttr("hidden");
      }
    } else {
      $("#provide-certify-warning").attr("hidden", "hidden");
    }
  });
  $('input[value="datamart-delta-data-providers"]').on("change", function () {
    if ($(this).is(":checked")) {
      if ($('input[value="datamart-delta-data-certifiers"]').is(":checked")) {
        $("#provide-certify-warning").removeAttr("hidden");
      }
    } else {
      $("#provide-certify-warning").attr("hidden", "hidden");
    }
  });
}

var certifyEnabled = false;

// Global variables, caching the DOM, accessible throughout this IIFE
var $dataAccessGroupsForm = $("#data-access-groups"),
  $orglistMaster,
  $orglistSlaves;

// If the above form exists...
if ($dataAccessGroupsForm.length) {
  $orglistMaster = $dataAccessGroupsForm.find(
    "#organisation.js-option-provider",
  );
  $orglistMaster.on("change", updateSlave);
  $orglistMaster.trigger("change");
}

function updateSlave(e) {
  $orglistSlaves = $dataAccessGroupsForm.find(
    '.js-option-consumer[data-js-option-ref="' +
      $orglistMaster.attr("id") +
      '"]',
  );
  // Fetch the lastest snapshot of the 'js-option-provider'
  var masterSelectedOrgs = $orglistMaster.find(":selected");

  // Check if there are any selected Slave <option>s
  var slavesWithSelectedOpts = getSlavesWithSelectedOpts();

  if (masterSelectedOrgs.length > 0) {
    // Feed the Slaves with the selected <option>s

    if (slavesWithSelectedOpts.length > 0) {
      // There are selected <options>s

      // preserve the selected <option>s while updating the Slave list
      populateSlaveWithSelectedMasterOpts(
        masterSelectedOrgs,
        slavesWithSelectedOpts,
      );
    } else {
      // Simply do a copy from Master to Slaves
      populateSlaveWithSelectedMasterOpts(masterSelectedOrgs);
    }
  } else {
    // Make sure that Slaves are clean, to reflect 'no Master selection'
    resetAllSlaves();
  }
}

function getSlavesWithSelectedOpts() {
  var _SLAVES = [],
    selectedSlaveOpts;

  $orglistSlaves.each(function (index, slave) {
    var slaveObject = { selectedOpts: null };

    selectedSlaveOpts = $(slave)
      .find(":selected")
      .get()
      .map(function (optionElement) {
        return optionElement.value;
      });

    if (selectedSlaveOpts.length > 0) {
      slaveObject = {
        selectElementIndex: index,
        selectedOpts: selectedSlaveOpts,
      };
      _SLAVES.push(slaveObject);
    }
  });

  return _SLAVES;
}

/**
 * Totally wipe clean, all Slaves;
 * i.e. Remove all exisiting <option>s from all Slaves
 */
function resetAllSlaves() {
  $orglistSlaves.each(function (i, slave) {
    // Clean out the Slave completely
    clearSelectedOpts(slave);
    removeAllOpts(slave);
  });
}

// Clear only the selected options view
function clearSelectedOpts(selectElement) {
  $(selectElement).val("").trigger("chosen:updated");
}

// Reset the 'js-option-consumers'; i.e. remove all <option> elements
function removeAllOpts(selectElement) {
  $(selectElement).empty().trigger("chosen:updated");
}

// Update the 'js-option-consumers' with the selected Orgs, from the 'js-option-provider' aka 'Master'
function populateSlaveWithSelectedMasterOpts(_masterSelectedOrgs) {
  // Totally wipe clean, all Slaves
  resetAllSlaves();

  // Then update/sync each Slave with the Master selections
  $orglistSlaves.each(function (slaveIndex, slave) {
    $(_masterSelectedOrgs).each(function (optIndex, opt) {
      $(slave)
        .append($("<option>").val(opt.value).text(opt.textContent))
        .trigger("chosen:updated");
    });
  });

  // If a second argument was supplied to this function when it was called,
  // expect it to be an Array, containing objects, each representing a Slave
  // which already has at least one <option> selected
  if (arguments.length > 1) {
    $(arguments[1]).each(function (index, selectElementObject) {
      $($orglistSlaves[selectElementObject.selectElementIndex])
        .val(selectElementObject.selectedOpts)
        .trigger("chosen:updated");
    });
  }
}

if (isInRequestApprovalPage()) {
  $("#provideS151Role").on("change", function () {
    if ($(this).is(":checked")) {
      $("#approval-btn").removeAttr("disabled");
    } else {
      $("#approval-btn").attr("disabled", "disabled");
    }
  });
}

if (false /*isInCertifierRolesPage() ) */) {
  $('input[type="radio"]').on("change", function (e) {
    $.ajax({
      type: "GET",
      dataType: "JSON",
      url: "/certifier/certifierRoleOrganisations.json",
    })
      .done(function (response) {
        $("#certifierOrganisation")
          .empty()
          .append('<option value=""></option>');
        $.each(response, function (key, value) {
          $("#certifierOrganisation").append(
            $("<option></option>").attr("value", key).text(value),
          );
        });
      })
      .fail(function (response) {
      });
  });
}
